import { render, staticRenderFns } from "./IncomeTypes.vue?vue&type=template&id=371b4767&"
import script from "./IncomeTypes.vue?vue&type=script&lang=js&"
export * from "./IncomeTypes.vue?vue&type=script&lang=js&"
import style0 from "./IncomeTypes.vue?vue&type=style&index=0&id=371b4767&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports